function normalize(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function countLeaveDaysInRange(
  userAvailability: { startDate: string; endDate?: string | null }[],
  taskStart: Date,
  taskEnd: Date
): number {
  let leaveDays = 0;

  // normalize task dates
  taskStart = normalize(new Date(taskStart));
  taskEnd = normalize(new Date(taskEnd));

  for (const leave of userAvailability) {
    const leaveStart = normalize(new Date(leave.startDate));
    const leaveEnd = leave.endDate
      ? normalize(new Date(leave.endDate))
      : leaveStart;

    const overlapStart = leaveStart > taskStart ? leaveStart : taskStart;
    const overlapEnd = leaveEnd < taskEnd ? leaveEnd : taskEnd;

    if (overlapStart <= overlapEnd) {
      // difference in calendar days
      const diffDays =
        Math.floor(
          (overlapEnd.getTime() - overlapStart.getTime()) / (1000 * 60 * 60 * 24)
        ) + 1;

      leaveDays += diffDays;
    }
  }

  return leaveDays;
}
